import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import { IQueryCommand } from "@features/filter";
import { Parameter } from "./classes/parameter";


@Injectable()
export class ParametersStoreService extends PagedCrudService<Parameter> {
    readonly url = "api/app-settings";
    readonly entityTitle = "Application Parameter";


    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }


    create(item: Parameter, responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<Parameter> {
        return this.handleRequest<Parameter>(
            this.http.post<Parameter>(`${this.url}`, item),
            this.handlersFactory.getForUpdate(this.entityTitle, responseHandlerSettings)
        ).then(() => item);
    }

    update(id: string, item: Parameter, responseHandlerSettings?: IHttpResponseHandlerSettings): Promise<Parameter> {
        return this.handleRequest<Parameter>(
            this.http.post<Parameter>(`${this.url}`, item),
            this.handlersFactory.getForUpdate(this.entityTitle, responseHandlerSettings)
        ).then(() => item);
    }

    getAppSettings(queryCommand: IQueryCommand): Promise<Parameter[]> {
        return this.handleRequest<Parameter[]>(
            this.http.get<Parameter[]>(this.url),
            this.handlersFactory.getForReadAll()
        );
    }

    isEnabled(): Promise<boolean> {
        return this.handleRequest<boolean>(
            this.http.get<boolean>(`${this.url}/is-enabled`),
            this.handlersFactory.getDefault()
        );
    }
}